let BACKEND_SERVER = null;
let BACKEND_DOMAIN = null;
let career_link = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
  // BACKEND_SERVER = " http://192.168.0.103:8000/"; 
  // BACKEND_SERVER = "http://localhost:8000/api/"
  // BACKEND_SERVER = "https://auto-recruiter-api.itconnectus.com/api/"
  BACKEND_SERVER = "https://dev-api.talchi.ai/api/"
  // BACKEND_SERVER = "https://itconnectus-api.talchi.ai/api/"
  // BACKEND_SERVER = "http://127.0.0.1:8000/api/";
  // BACKEND_WS_SERVER = "wss://192.168.0.103:8000/";

  // BACKEND_DOMAIN = "http://127.0.0.1:8000"
  // BACKEND_DOMAIN = "https://auto-recruiter-api.itconnectus.com"
  BACKEND_DOMAIN = "https://dev-api.talchi.ai"
  // BACKEND_DOMAIN = "https://itconnectus-api.talchi.ai"

  //career_link = "http://localhost:3001/careers/" //"https://career.itconnectus.com/career/" //
  career_link = "https://itconnectus.talchi.ai/careers/"
  // career_link = "https://dev.talchi.ai/careers/" //"https://itconnectus.talchi.ai/careers/"
}

const config = {
    basename: '',
    defaultPath: '/dashboard',
    defaultPath1: '/logout',
    fontFamily: "Work Sans, sans-serif",
    borderRadius: 3,
    API_SERVER: BACKEND_SERVER,
    BACKEND_DOMAIN: BACKEND_DOMAIN,
    career_server: career_link,
    TITLE_TXT: 'Talchi ai',
    organization_id: 1,
    ENCRYPT_KEY: "encrypt_item_key",
    LINKEDIN_CLIENT_ID: '86l31756beisu2',
    OTP_VALIDITY: 120,
    PROFILES_PER_PAGE: 24
};

export default config;
